/* Aura — botao de compra com a economia da barra escolhida, igual a referencia.
   So age quando a pagina tem widget de bundle; sem widget, o botao do tema
   fica intocado. Falha aberto. */
(function () {
  'use strict';

  var ICONE = '<svg class="aura-atc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var BASE = 'Add to Cart';

  function numero(el) {
    if (!el) return null;
    var m = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var v = parseFloat(m);
    return isNaN(v) ? null : v;
  }

  function iniciar() {
    var raiz = document.querySelector('.aura-bundle');
    if (!raiz) return;
    var btn = document.querySelector('.product-form__submit');
    var span = btn && btn.querySelector('span');
    if (!span) return;

    function textoAlvo() {
      var sel = raiz.querySelector('.aura-bar-wrap.is-selected');
      if (sel) {
        var preco = numero(sel.querySelector('[data-aura-price]'));
        var cheio = numero(sel.querySelector('[data-aura-full]:not([hidden])'));
        if (preco != null && cheio != null && cheio > preco) {
          return BASE + ' & SAVE $' + Math.round(cheio - preco);
        }
      }
      return BASE;
    }

    function aplicar() {
      try {
        var alvo = textoAlvo();
        // compara o conteudo real: se o tema reescrever o span, isto conserta
        if (span.textContent.trim() !== alvo || !span.querySelector('.aura-atc-icon')) {
          span.innerHTML = ICONE + alvo;
        }
      } catch (e) { /* falha aberto */ }
    }

    var pendente = false;
    function agendar() {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(function () { pendente = false; aplicar(); });
    }

    aplicar();
    new MutationObserver(agendar).observe(raiz, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true, characterData: true });
    new MutationObserver(agendar).observe(span, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
